import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import AboutSection from "./components/AboutSection";
import EquipmentSection from "./components/EquipmentSection";
import ServicesSection from "./components/ServicesSection";
import PartnersSection from "./components/PartnersSection";
import TeamSection from "./components/TeamSection";
import Footer from "./components/Footer";
import BookingModal from "./components/BookingModal";
import CookieBanner from "./components/CookieBanner";
import Datenschutz from "./components/pages/Datenschutz";
import Impressum from "./components/pages/Impressum";
import CookieRichtlinie from "./components/pages/CookieRichtlinie";
import EquipmentDetailPage from "./components/pages/EquipmentDetailPage";
import Schulungen from "./components/pages/Schulungen";
import PartnerLiftPage from "./components/pages/PartnerLiftPage";
import AGB from "./components/pages/AGB";
import Seo from "./components/Seo";

const HomePage = ({ onBookingOpen }) => (
  <>
    <Seo />
    <Hero onBookingOpen={onBookingOpen} />
    <AboutSection onBookingOpen={onBookingOpen} />
    <EquipmentSection />
    <ServicesSection />
    <PartnersSection />
    <TeamSection />
    <Footer />
  </>
);

const SubPageLayout = ({ children }) => (
  <>
    {children}
    <Footer />
  </>
);

function App() {
  const [bookingOpen, setBookingOpen] = useState(false);

  return (
    <div className="App">
      <BrowserRouter>
        <Navbar onBookingOpen={() => setBookingOpen(true)} />
        <Routes>
          <Route
            path="/"
            element={<HomePage onBookingOpen={() => setBookingOpen(true)} />}
          />
          <Route path="/datenschutz" element={<SubPageLayout><Seo title="Datenschutz – Brinckmann Arbeitsbühnen" description="Datenschutzerklärung der Brinckmann Arbeitsbühnen GmbH, Bocholt." /><Datenschutz /></SubPageLayout>} />
          <Route path="/impressum" element={<SubPageLayout><Seo title="Impressum – Brinckmann Arbeitsbühnen" description="Impressum und Anbieterkennzeichnung der Brinckmann Arbeitsbühnen GmbH, Ruhrallee 13, 46395 Bocholt." /><Impressum /></SubPageLayout>} />
          <Route path="/cookies" element={<SubPageLayout><Seo title="Cookie-Richtlinie – Brinckmann Arbeitsbühnen" description="Informationen zu Cookies auf der Website von Brinckmann Arbeitsbühnen." /><CookieRichtlinie /></SubPageLayout>} />
          <Route path="/geraete/:slug" element={<SubPageLayout><EquipmentDetailPage /></SubPageLayout>} />
          <Route path="/schulungen" element={<SubPageLayout><Seo title="Schulungen & Bedienerausbildung – Brinckmann Arbeitsbühnen" description="Schulungen und Bedienerausbildung für Arbeitsbühnen und Höhenzugangstechnik bei Brinckmann Arbeitsbühnen, Bocholt." /><Schulungen /></SubPageLayout>} />
          <Route path="/partnerlift" element={<SubPageLayout><Seo title="PartnerLIFT-Netzwerk – Brinckmann Arbeitsbühnen" description="Über 15.000 Arbeitsbühnen im bundesweiten PartnerLIFT-Netzwerk – verfügbar über Brinckmann Arbeitsbühnen." /><PartnerLiftPage /></SubPageLayout>} />
          <Route path="/agb" element={<SubPageLayout><Seo title="AGB – Brinckmann Arbeitsbühnen" description="Allgemeine Geschäftsbedingungen der Brinckmann Arbeitsbühnen GmbH." /><AGB /></SubPageLayout>} />
        </Routes>
        <BookingModal
          isOpen={bookingOpen}
          onClose={() => setBookingOpen(false)}
        />
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
